define('views/app/member/member',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'toastr', 'services/i18n',
    //services
    'services/user',
    'services/events/user-events',
    // Views
    'src/views/responsive-view',
    'views/parts/menu/menu',
    'views/parts/header/default-header',
    'views/modules/calendar/calendar/calendar',
    'views/modules/graph/graph',
    'views/modules/goal/goal',
    'views/modules/conversation/conversation',
    'views/modules/note/note',
    // Templates
    'text!templates/app/member/member.html'
], function(
    // Libs
    _, Backbone, Mustache, U, Toastr, i18n,
    //services
    User,
    UserEvents,
    // Views
    VResponsive,
    VMenu,
    VDefaultHeader,
    VCalendar,
    VGraph,
    VGoal,
    VConversation,
    VNote,
    // Templates
    TAppMember
) {
    var pageViewMap = {
        calendar: VCalendar,
        graph: VGraph,
        goal: VGoal,
        message: VConversation,
        note: VNote
    };

    var VAppMember = VResponsive.extend({

        template: TAppMember,

        regions: {
            header: '#header',
            content: '#content',
        },

        initialize: function(opt) {
            opt = opt || {};

            this.group = opt.group;
            this.role = opt.role;
            this.url = opt.url;

            this.setUrl("root", "#/" + this.url.root);

            // Inistialize Views
            this.view = {
                header: new VDefaultHeader(),
            };

            this.listenTo(UserEvents, 'switchMode', this.onSwitchMode);
        },

        render: function() {
            // Render Template HTML with Mustache
            var html = Mustache.render(this.template);
            this.$el.empty().append(html);

            this.generateZones();
            var zone = this.zone,
                view = this.view;

            this.assign(view.header, zone.$header);

            if (view.content) {
                this.assign(view.content, zone.$content);
            }

            this.verifyUserGroupMembership();

            this.setRollbarLoggerProfile();

        },

        setRollbarLoggerProfile: function() {
            // Set the person data to be sent with all errors for this notifier.
            window.Rollbar.configure({
              payload: {
                person: {
                  id: User.get('_id'),
                  username: User.get('displayName'),
                  email: User.get('email')
                }
              }
            });

        },

        verifyUserGroupMembership: function() {
            if (U.getCookieByName('TCNeddExpirationToastr') === "true") {
                var message = i18n.t("messages:message-expiration-in-one-group"),
                    title = i18n.t("Expiration");

                Toastr.error(
                    message,
                    title, { // These options should be set globally.
                        positionClass: "toast-top-center", // Default = toast-top-right
                        newestOnTop: true, // Default = true
                        showMethod: "slideDown",    // Default = fadeIn
                        tapToDismiss: true,  // Default = false
                        closeButton: true
                    }
                );
                document.cookie = "TCNeddExpirationToastr=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            }
        },
        /////////////
        // Content //
        /////////////
        showPage: function(key, options) {
            options = options || {};
            var url = this.url,
                viewObj = this.view,
                view = viewObj[key],
                content = viewObj.content;

            if (!view) {
                view = viewObj[key] = new pageViewMap[key]({
                    model: this.model, // pass the user profile model
                    group: this.group, // current group
                    url: url,
                    role: this.role,
                });
            }

            view.setUrl("root", '#/' + url[key]);
            this.setHeader(view);

            if (content !== view) {
                if (content) content.disable();
                content = viewObj.content = view;
                this.assign(content, this.zone.$content);
            }
            return this;
        },

        setHeader: function(view) {
            var header = this.view.header;
            header.setTitle(_.result(view, 'title', false));
            header.setSubtitle(_.result(view, 'subtitle', false));
            header.setSkipTranslation(_.result(view, 'skipTranslation', false));
        },

        getView: function(key, options) {
            var viewObj = this.view,
                view = viewObj[key];
            if (!view) {
                view = viewObj[key] = new pageViewMap[key](options);
            }
            return view;
        },

        ////////////
        // events //
        ////////////

        onResize: function(e, width) {
            if (this.view && this.view.content && this.view.content.onResize) {
                this.view.content.onResize(e, width);
            }
        },

        onSwitchMode: function() {
            this.view.content.disable();
        }

    });

    return VAppMember;

});

